/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography, Typography2, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import ExploreButton from 'bundles/video-logged-out-page/components/ExploreButton';

import _t from 'i18n!nls/video-logged-out-page';

const styles = {
  exploreBanner: css`
    flex-direction: column;
    background-image: linear-gradient(90deg, #4fc1e9, var(--cds-color-blue-700));
    padding: var(--cds-spacing-600);

    .vlp-explore-button {
      font-weight: normal;
    }
  `,
  exploreHeader: (theme: Theme) =>
    css({
      marginBottom: 'var(--cds-spacing-400)',
    }),
  exploreSubtitle: css({
    marginBottom: '40px',
  }),
};

const ExploreBanner: React.FC<{}> = () => {
  const theme = useTheme();
  const buttonText = _t('Get Started');
  const subTitle = _t('Join for free and get personalized recommendations, updates and offers.');
  const title = _t('Explore our Catalog');

  return (
    <Grid data-unit="vlp-explore" container alignItems="center" className="vlp-explore" css={styles.exploreBanner}>
      <Typography color="invertBody" component="h2" variant="h2semibold" css={styles.exploreHeader(theme)}>
        {title}
      </Typography>
      {subTitle && (
        <Typography2 color="invertBody" component="h3" variant="subtitleMedium" css={styles.exploreSubtitle}>
          {subTitle}
        </Typography2>
      )}
      <ExploreButton title={buttonText} url="/browse/" buttonClass="vlp-explore-button" />
    </Grid>
  );
};

export default ExploreBanner;
